//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import bottom from "@/assets/img/bottom.png";
import { getUrlparams, countDownTimeFunc, toCopy } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import { Dialog, Toast } from "vant";
import * as dd from "dingtalk-jsapi";

export default {
  name: "Home",
  components: {
    footerNav
  },
  data() {
    return {
      finished: false,
      refreshing: false,
      bottom,
      buyPlanList: [],
      purchaseList: [],
      someQualityOrderList: [],
      tagType: 1,
      tagTypeDown: 1,
      list: [],
      chooseItem: [
        { label: "采购单", isChoose: true },
        { label: "生产许可证", isChoose: false },
        { label: "面辅料跟进单", isChoose: false },
        { label: "成衣工序汇报", isChoose: false },
        { label: "送货单", isChoose: false },
        { label: "质检单", isChoose: false },
        { label: "入库单", isChoose: false },
        { label: "质检退货单", isChoose: false },
        { label: "返工单", isChoose: false }
      ],
      loading: false,
      finished: true,
      show: false,
      sendOrderlist: [],
      sendOrderList: [],
      toCopy,
      allQualityOrderList: [],
      noQualityOrderList: []
    };
  },
  created() {
    console.log(this.$route);
  },
  mounted() {
    this.queryList();
  },
  updated() {
    document.scrollingElement.scrollTop = 0;
  },
  methods: {
    hasBtn(id) {
      var obj = false;
      this.$store.state.menus.forEach(item => {
        if (item.title == "送货单") {
          item.requestUrlList.forEach(element => {
            if (element.id == id) {
              obj = true;
            }
          });
        }
      });
      return obj;
    },
    queryList(num) {
      if (num == 1) {
        if (this.tagTypeDown == 1) {
          this.buyPlanQuery();
        }
        if (this.tagTypeDown == 2) {
          this.purchaseQuery();
        }
        if (this.tagTypeDown == 3) {
          this.sendOrderQuery();
        }
        if (this.tagTypeDown == 4) {
          this.allQualityOrderQuery();
        }
        if (this.tagTypeDown == 5) {
          this.qualityOrderQuery();
        }
      } else {
        const type = this.tagType;
        if (type && type == 1) {
          this.empty();
        }
        if (type == 1) {
          this.querySendOrder();
        } else if (type == 3) {
          if (this.tagTypeDown == 1) {
            this.buyPlanQuery(1);
          }
          if (this.tagTypeDown == 2) {
            this.purchaseQuery(1);
          }
          if (this.tagTypeDown == 3) {
            this.sendOrderQuery(1);
          }
          if (this.tagTypeDown == 4) {
            this.allQualityOrderQuery(1);
          }
          if (this.tagTypeDown == 5) {
            this.qualityOrderQuery(1);
          }
        }
        // this.queryProcessing();
      }
      // if (this.$store.state.menus.length > 0) {
      //   for (var i in this.$store.state.menus) {
      //     if (this.$store.state.menus[i].name == "sendOrder") {
      //       this.querySendOrder();
      //       return;
      //     } else if (this.$store.state.menus[i].name == "qualityAllTestOrder") {
      //       this.queryQualityAllTestOrder();
      //       return;
      //     } else if (this.$store.state.menus[i].name == "qualityTestOrder") {
      //       this.queryQualitySomeTestOrder();
      //       return;
      //     } else if (this.$store.state.menus[i].name == "qualityNoTestOrder") {
      //       this.queryQualityNoTestOrder();
      //       return;
      //     }
      //   }
      // }
    },
    submitGO(item) {
      this.idList = [];
      var params = { planOrderIdList: [item], planStatus: 1 };
      axiosApi.purchaseUpdate(params).then(response => {
        Toast.success("提交成功");
        this.empty();
        this.buyPlanQuery(1);
      });
    },
    backAudit(item) {
      Dialog.confirm({
        title: "提示",
        message:
          "确认进行此操作?如质检单采购审核已生成全检单或返工单,需操作作废!"
      })
        .then(() => {
          var queryParams = { qualityOrderIdList: [item.qualityOrderId] };
          axiosApi
            .unAuditQuality(queryParams)
            .then(response => {
              Toast.success("操作成功");
              this.queryList();
            })
            .catch(error => {});
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    },
    toAudit(item) {
      this.$router.push({
        name: "qualityAudit",
        query: { qualityOrderId: item.qualityOrderId }
      });
    },
    auditGO(item) {
      this.idList = [];
      var params = { planOrderIdList: [item], planStatus: 3, rejectRemark: "" };
      axiosApi.purchaseAudit(params).then(response => {
        Toast.success("审核成功");
        this.empty();
        this.buyPlanQuery(1);
      });
    },
    rejectedGO(item) {
      this.idList = [];
      var params = {
        planOrderIdList: [item],
        planStatus: 4,
        rejectRemark: "驳回"
      };
      axiosApi.purchaseAudit(params).then(response => {
        Toast.success("驳回成功");
        this.empty();
        this.buyPlanQuery(1);
      });
    },
    IssuedGO(item) {
      this.$router.push({
        name: "buyPlanIssued",
        query: {
          planOrderId: [item.planOrderId]
        }
      });
      this.empty();
      this.buyPlanQuery(1);
    },

    queryQualityNoTestOrder() {
      var queryParams = {
        qualityOrderType: 3,
        start: this.noQualityOrderList.length,
        size: 10,
        orderRules: [
          { orderKey: "recTime", desc: true },
          { orderKey: "qualityOrderId", desc: true }
        ],
        desc: true
      };
      if (
        this.$store.state.defultValue.hasOwnProperty("qualityOrderStatusList")
      ) {
        queryParams.qualityOrderStatusList = this.$store.state.defultValue.qualityOrderStatusList;
      }
      axiosApi
        .queryQualityOrderList(queryParams)
        .then(response => {
          if (
            response.content &&
            response.content.list &&
            response.content.list.length > 0
          ) {
            response.content.list.forEach(item => {
              var channelStr = "";
              if (item.firstDeptName) {
                channelStr += item.firstDeptName;
              }
              if (item.secondDeptName) {
                channelStr += "/" + item.secondDeptName;
              }
              item.channelStr = channelStr;
              if (item.isStockIn == 1) {
                item.isStockInStr = "是";
              }
              if (item.isStockIn == 0) {
                item.isStockInStr = "否";
              }
              if (item.isRedone == 1) {
                item.isRedoneStr = "是";
              }
              if (item.isRedone == 0) {
                item.isRedoneStr = "否";
              }
            });
            this.noQualityOrderList = this.noQualityOrderList.concat(
              response.content.list
            );
          }
          this.loading = false;
          this.refreshing = false;
          if (this.noQualityOrderList.length == response.content.total) {
            this.finished = true;
          }
        })
        .catch(error => {});
    },
    deleteRow(item) {
      Dialog.confirm({
        title: "提示",
        message: "确认作废？"
      })
        .then(() => {
          var queryParams = {
            qualityOrderStatus: -1,
            qualityOrderIdList: [item.qualityOrderId]
          };
          axiosApi
            .cancelQualityOrder(queryParams)
            .then(response => {
              Toast.success("操作成功");
              this.queryList();
            })
            .catch(error => {});
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    },
    backSubmit(item) {
      Dialog.confirm({
        title: "提示",
        message: "确认进行此操作？"
      })
        .then(() => {
          var queryParams = { qualityOrderIdList: [item.qualityOrderId] };
          axiosApi
            .clearQualityOrderResult(queryParams)
            .then(response => {
              Toast.success("操作成功");
              this.queryList();
            })
            .catch(error => {});
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    },
    showCheck(item) {
      if (item.qualityResultId) {
        this.$router.push({
          name: "qualityWrite",
          query: {
            qualityResultId: item.qualityResultId,
            qualityOrderId: item.qualityOrderId
          }
        });
      } else if (item.qualityOrderDetailList.length == 1) {
        this.$router.push({
          name: "qualityWrite",
          query: { data: JSON.stringify([item]) }
        });
      }
    },
    hasMenu(menu) {
      return (
        this.$store.state.menus.filter(item => {
          return item.name == menu;
        }).length > 0
      );
    },
    changeTag(type) {
      this.tagType = type;
      this.empty();
      if (type == 3) {
        this.changeTagDown(1);
      }
      if (type == 1) {
        this.querySendOrder();
      }
    },
    onLoad() {
      if (this.tagType == 3) {
        if (this.tagTypeDown == 1) {
          if (this.buyPlanList.length != 0) {
            this.queryList(1);
          }
        }
        if (this.tagTypeDown == 2) {
          if (this.purchaseList.length != 0) {
            this.queryList(1);
          }
        }
        if (this.tagTypeDown == 3) {
          if (this.sendOrderList.length != 0) {
            this.queryList(1);
          }
        }
        if (this.tagTypeDown == 4) {
          if (this.allQualityOrderList.length != 0) {
            this.queryList(1);
          }
        }
        if (this.tagTypeDown == 5) {
          if (this.someQualityOrderList.length != 0) {
            this.queryList(1);
          }
        }
      }
    },
    empty() {
      this.buyPlanList = [];
      this.purchaseList = [];
      this.sendOrderList = [];
      this.allQualityOrderList = [];
      this.someQualityOrderList = [];
      this.sendOrderlist = [];
    },
    changeTagDown(type) {
      this.tagTypeDown = type;
      this.finished = false;
      this.refreshing = false;
      this.loading = false;
      this.empty();
      if (this.tagTypeDown == 1) {
        this.buyPlanQuery();
      }
      if (this.tagTypeDown == 2) {
        this.purchaseQuery();
      }
      if (this.tagTypeDown == 3) {
        this.sendOrderQuery();
      }
      if (this.tagTypeDown == 4) {
        this.allQualityOrderQuery();
      }
      if (this.tagTypeDown == 5) {
        this.qualityOrderQuery();
      }
    },
    // qualityOrderQuery() {
    //   const data = this.searchDefault("qualityOrder");
    // },
    allQualityOrderQuery(type) {
      if (type == 1) {
        this.empty();
      }
      axiosApi
        .getMangeSearchDefault({ menuName: "qualityAllTestOrder" })
        .then(res => {
          if (res && res.content && res.content.searchValue) {
            const data = res.content.searchValue;
            var params = {
              ...data,
              spuCodeList: data.spuCodeList ? data.spuCodeList.split(" ") : [],
              purchaseOrderSnList: data.purchaseOrderSnList
                ? data.purchaseOrderSnList.split(" ")
                : [],
              sendOrderSnList: data.sendOrderSnList
                ? data.sendOrderSnList.split(" ")
                : [],
              qualityOrderSnList: data.qualityOrderSnList
                ? data.qualityOrderSnList.split(" ")
                : [],
              colorValueList: data.colorValueList
                ? data.colorValueList.split(" ")
                : [],
              skuCodeList: data.skuCodeList ? data.skuCodeList.split(" ") : [],
              remarkList: data.remarkList ? data.remarkList.split(" ") : [],
              planOrderSnList: data.planOrderSnList
                ? data.planOrderSnList.split(" ")
                : [],
              externalOrderList: data.externalOrderList
                ? data.externalOrderList.split(" ")
                : [],
              start: this.allQualityOrderList.length,
              size: 10,
              orderRules: [
                { orderKey: "recTime", desc: true },
                { orderKey: "qualityOrderId", desc: true }
              ],
              desc: true
            };
            axiosApi.queryQualityOrderList(params).then(res => {
              if (
                res.content &&
                res.content.list &&
                res.content.list.length > 0
              ) {
                res.content.list.forEach(item => {
                  var channelStr = "";
                  if (item.firstDeptName) {
                    channelStr += item.firstDeptName;
                  }
                  if (item.secondDeptName) {
                    channelStr += "/" + item.secondDeptName;
                  }
                  item.channelStr = channelStr;
                  if (item.isStockIn == 1) {
                    item.isStockInStr = "是";
                  }
                  if (item.isStockIn == 0) {
                    item.isStockInStr = "否";
                  }
                  if (item.isRedone == 1) {
                    item.isRedoneStr = "是";
                  }
                  if (item.isRedone == 0) {
                    item.isRedoneStr = "否";
                  }
                });
                this.allQualityOrderList = this.allQualityOrderList.concat(
                  res.content.list
                );
              }
              this.loading = false;
              this.refreshing = false;
              if (this.allQualityOrderList.length == res.content.total) {
                this.finished = true;
              }
            });
          } else {
            this.finished = true;
          }
        });
    },
    purchaseQuery(type) {
      if (type == 1) {
        this.empty();
      }
      axiosApi.getMangeSearchDefault({ menuName: "purchase" }).then(res => {
        if (res && res.content && res.content.searchValue) {
          const data = res.content.searchValue;
          var params = {
            ...data,
            purchaseOrderSnList: data.purchaseOrderSnList
              ? data.purchaseOrderSnList.split(" ")
              : [],
            planOrderSnList: data.planOrderSnList
              ? data.planOrderSnList.split(" ")
              : [],
            spuCodeList: data.spuCodeList ? data.spuCodeList.split(" ") : [],
            colorValueList: data.colorValueList
              ? data.colorValueList.split(" ")
              : [],
            skuCodeList: data.skuCodeList ? data.skuCodeList.split(" ") : [],
            remarkList: data.remarkList ? data.remarkList.split(" ") : [],
            stockInSnList: data.stockInSnList
              ? data.stockInSnList.split(" ")
              : [],
            contractNameList: data.contractNameList
              ? data.contractNameList.split(" ")
              : [],
            start: this.purchaseList.length,
            size: 10,
            orderRules: [{ orderKey: "purchaseOrderId", desc: true }],
            desc: true
          };
          axiosApi.queryPurchaseList(params).then(res => {
            if (
              res.content &&
              res.content.list &&
              res.content.list.length > 0
            ) {
              res.content.list.forEach(item => {
                var channelStr = "";
                if (item.firstDeptName) {
                  channelStr += item.firstDeptName;
                }
                if (item.secondDeptName) {
                  channelStr += "/" + item.secondDeptName;
                }
                item.channelStr = channelStr;
                if (item.isStockIn == 1) {
                  item.isStockInStr = "是";
                }
                if (item.isStockIn == 0) {
                  item.isStockInStr = "否";
                }
                if (item.isRedone == 1) {
                  item.isRedoneStr = "是";
                }
                if (item.isRedone == 0) {
                  item.isRedoneStr = "否";
                }
              });
              this.purchaseList = this.purchaseList.concat(res.content.list);
            }
            this.loading = false;
            this.refreshing = false;
            if (this.purchaseList.length == res.content.total) {
              this.finished = true;
            }
          });
        } else {
          this.finished = true;
        }
      });
    },
    buyPlanQuery(type) {
      if (type == 1) {
        this.empty();
      }
      axiosApi.getMangeSearchDefault({ menuName: "buyPlan" }).then(res => {
        if (res && res.content && res.content.searchValue) {
          const data = res.content.searchValue;
          var params = {
            ...data,
            spuCodeList: data.spuCodeList ? data.spuCodeList.split(" ") : [],
            colorValueList: data.colorValueList
              ? data.colorValueList.split(" ")
              : [],
            planOrderSnList: data.planOrderSnList
              ? data.planOrderSnList.split(" ")
              : [],
            skuCodeList: data.skuCodeList ? data.skuCodeList.split(" ") : [],
            remarkList: data.remarkList ? data.remarkList.split(" ") : [],
            start: this.buyPlanList.length,
            size: 10,
            orderRules: [{ orderKey: "t2.planOrderId", desc: true }],
            desc: true
          };
          axiosApi.queryPlanList(params).then(res => {
            if (
              res.content &&
              res.content.list &&
              res.content.list.length > 0
            ) {
              res.content.list.forEach(item => {
                var channelStr = "";
                if (item.firstDeptName) {
                  channelStr += item.firstDeptName;
                }
                if (item.secondDeptName) {
                  channelStr += "/" + item.secondDeptName;
                }
                item.channelStr = channelStr;
              });
              this.buyPlanList = this.buyPlanList.concat(res.content.list);
            }
            this.loading = false;
            this.refreshing = false;
            if (this.buyPlanList.length == res.content.total) {
              this.finished = true;
            }
          });
        } else {
          this.finished = true;
        }
      });
    },
    querySendOrder() {
      var params = {
        sendOrderStatusList: ["1"],
        start: this.sendOrderlist.length,
        size: 10,
        orderRules: [
          { orderKey: "recTime", desc: true },
          { orderKey: "sendOrderId", desc: true }
        ],
        desc: true
      };
      axiosApi.getSendOrderList(params).then(res => {
        if (res.content.list && res.content.list.length > 0) {
          res.content.list.forEach(item => {
            var channelStr = "";
            if (item.firstDeptName) {
              channelStr += item.firstDeptName;
            }
            if (item.secondDeptName) {
              channelStr += "/" + item.secondDeptName;
            }
            item.channelStr = channelStr;
          });
          this.sendOrderlist = this.sendOrderlist.concat(res.content.list);
        }
        this.loading = false;
        this.refreshing = false;
        if (this.sendOrderlist.length == res.content.total) {
          this.finished = true;
        }
      });
    },
    sendOrderQuery(type) {
      if (type == 1) {
        this.empty();
      }
      axiosApi.getMangeSearchDefault({ menuName: "sendOrder" }).then(res => {
        if (res && res.content && res.content.searchValue) {
          const data = res.content.searchValue;
          var params = {
            ...data,
            spuCodeList: data.spuCodeList ? data.spuCodeList.split(" ") : [],
            purchaseOrderSnList: data.purchaseOrderSnList
              ? data.purchaseOrderSnList.split(" ")
              : [],
            sendOrderSnList: data.sendOrderSnList
              ? data.sendOrderSnList.split(" ")
              : [],
            planOrderSnList: data.planOrderSnList
              ? data.planOrderSnList.split(" ")
              : [],
            skuCodeList: data.skuCodeList ? data.skuCodeList.split(" ") : [],
            colorValueList: data.colorValueList
              ? data.colorValueList.split(" ")
              : [],
            remarkList: data.remarkList ? data.remarkList.split(" ") : [],
            start: this.sendOrderList.length,
            size: 10,
            orderRules: [
              { orderKey: "recTime", desc: true },
              { orderKey: "sendOrderId", desc: true }
            ],
            desc: true
          };
          axiosApi.getSendOrderList(params).then(res => {
            if (
              res.content &&
              res.content.list &&
              res.content.list.length > 0
            ) {
              res.content.list.forEach(item => {
                var channelStr = "";
                if (item.firstDeptName) {
                  channelStr += item.firstDeptName;
                }
                if (item.secondDeptName) {
                  channelStr += "/" + item.secondDeptName;
                }
                item.channelStr = channelStr;
              });
              this.sendOrderList = this.sendOrderList.concat(res.content.list);
            }
            this.loading = false;
            this.refreshing = false;
            if (this.sendOrderList.length == res.content.total) {
              this.finished = true;
            }
          });
        } else {
          this.finished = true;
        }
      });
    },
    qualityOrderQuery(type) {
      if (type == 1) {
        this.empty();
      }
      axiosApi
        .getMangeSearchDefault({ menuName: "qualityTestOrder" })
        .then(res => {
          if (res && res.content && res.content.searchValue) {
            const data = res.content.searchValue;
            var params = {
              ...data,
              spuCodeList: data.spuCodeList ? data.spuCodeList.split(" ") : [],
              purchaseOrderSnList: data.purchaseOrderSnList
                ? data.purchaseOrderSnList.split(" ")
                : [],
              sendOrderSnList: data.sendOrderSnList
                ? data.sendOrderSnList.split(" ")
                : [],
              qualityOrderSnList: data.qualityOrderSnList
                ? data.qualityOrderSnList.split(" ")
                : [],
              colorValueList: data.colorValueList
                ? data.colorValueList.split(" ")
                : [],
              skuCodeList: data.skuCodeList ? data.skuCodeList.split(" ") : [],
              remarkList: data.remarkList ? data.remarkList.split(" ") : [],
              planOrderSnList: data.planOrderSnList
                ? data.planOrderSnList.split(" ")
                : [],
              start: this.someQualityOrderList.length,
              size: 10,
              orderRules: [
                { orderKey: "recTime", desc: true },
                { orderKey: "qualityOrderId", desc: true }
              ],
              desc: true
            };
            axiosApi.querySpotcheckList(params).then(res => {
              if (
                res.content &&
                res.content.list &&
                res.content.list.length > 0
              ) {
                res.content.list.forEach(item => {
                  var channelStr = "";
                  if (item.firstDeptName) {
                    channelStr += item.firstDeptName;
                  }
                  if (item.secondDeptName) {
                    channelStr += "/" + item.secondDeptName;
                  }
                  item.channelStr = channelStr;
                  if (item.isStockIn == 1) {
                    item.isStockInStr = "是";
                  }
                  if (item.isStockIn == 0) {
                    item.isStockInStr = "否";
                  }
                  if (item.isRedone == 1) {
                    item.isRedoneStr = "是";
                  }
                  if (item.isRedone == 0) {
                    item.isRedoneStr = "否";
                  }
                  if (
                    item.someQualityOrderList &&
                    item.someQualityOrderList.length > 0
                  ) {
                    item.someQualityOrderList.forEach(item => {
                      item.choose = false;
                    });
                  }
                });
                this.someQualityOrderList = this.someQualityOrderList.concat(
                  res.content.list
                );
              }
              this.loading = false;
              this.refreshing = false;
              if (this.someQualityOrderList.length == res.content.total) {
                this.finished = true;
              }
            });
          } else {
            this.finished = true;
          }
        });
    },
    toPurchase() {
      this.$router.push({ name: "purchase" });
    },
    toBuyPlan() {
      this.$router.push({ name: "buyPlan" });
    },
    toProductCertificate() {
      this.$router.push({ name: "productCertificate" });
    },
    toFollowOrder() {
      this.$router.push({ name: "followOrder" });
    },
    toReport() {
      this.$router.push({ name: "report" });
    },
    toSend() {
      this.$router.push({ name: "sendOrder" });
    },
    toQuality() {
      this.$router.push({ name: "qualityOrder" });
    },
    toAllQuality() {
      this.$router.push({ name: "allQualityOrder" });
    },
    toNoQuality() {
      this.$router.push({ name: "noQualityOrder" });
    },
    toImport() {
      this.$router.push({ name: "importReport" });
    },
    toRefund() {
      this.$router.push({ name: "refundOrder" });
    },
    toBack() {
      this.$router.push({ name: "backOrder" });
    },
    toCenter() {
      this.$router.push({ name: "centerOrder" });
    },
    toActivitiesSelection() {
      this.$router.push({ name: "activitiesSelection" });
    },
    copySuccess() {
      Toast.success("复制成功");
    },
    toDetail() {
      // this.$router.push({name:'sendOrderDetail'})
    },
    toGet(sendOrderId) {
      this.$router.push({
        name: "warehouseGet",
        query: { sendOrderId: sendOrderId }
      });
    },
    toProcessing(purchaseOrderId) {
      this.$router.push({
        name: "procurementClearance",
        query: { purchaseOrderId: purchaseOrderId }
      });
    },
    goPurchase(item) {
      if (item.planStatus != 0) {
        this.$router.push({
          name: "buyPlanView",
          query: {
            item: item,
            type: "view"
          }
        });
      } else {
        this.$router.push({
          name: "buyPlanView",
          query: {
            item: item,
            type: "edit"
          }
        });
      }
    },
    toAll(qualityOrderId) {
      this.$router.push({
        name: "allQualityDetail",
        query: { qualityOrderId: qualityOrderId }
      });
    },
    toSome(row) {
      this.$router.push({
        name: "someQualityDetail",
        query: { data: JSON.stringify(row) }
      });
    },
    choose() {
      this.show = true;
    },
    selectItem(index) {
      this.chooseItem[index].isChoose = !this.chooseItem[index].isChoose;
    },
    chooseConfirm() {
      this.show = false;
    },
    toPurchaseDetail() {
      this.$router.push({ name: "purchaseDetail" });
    },
    toCode() {
      var that = this;
      dd.biz.util.scan({
        onSuccess: data => {
          // alert(JSON.stringify(data))
          that.$router.push({
            name: "warehouseGet",
            query: { sendOrderId: data.text }
          });
        },
        onFail: function(err) {}
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/home/index.vue